/* eslint-disable no-undef */
/* eslint-disable no-console */

document.addEventListener(
	'DOMContentLoaded',
	() => {
		new Mmenu('#mobile-menu', {
				slidingSubmenus: false,
				pageScroll: true,
				extensions: [
					'pagedim-black',
					'position-left',
					'position-front',
					'theme-dark',
				],
				counters: false,
				onClick: {
					close: true,
				},
				navbars: [
					{
						position: 'top',
						content: [
							'prev',
							'',
							'close'
						],
					},
				],
			}
		);
	}
);

// import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
// import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';

import VanillaCalendar from 'vanilla-calendar-pro';
// import imagesLoaded from 'imagesloaded';
import 'lazysizes';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import noUiSlider from 'nouislider';

(function ($) {

	// Global Window Object

	/**
	 * All the Google Maps code is in the global window object.
	 * This is to ensure that the Google Maps API can find the callback function.
	 * The callback function is defined in the global window object.
	 * The callback function is called by the Google Maps API when the API is loaded.
	 * The callback function initializes the Google Maps.
	 *
	 * Do NOT move the Google Maps code into a jQuery document ready function.
	 */

	// ------------------------------ //
	// Google Single Property Map
	function mp_initialize(mapElement) {

		let map,
			mp_lat = $('.property-location-map').data('map-latitude'),
			mp_lng = $('.property-location-map').data('map-longitude'),
			mp_zoom = 16,
			map_canvas = mapElement;

		let googleCenter = [ mp_lat, mp_lng ];

		let setDraggable = false;

		// on initial page load
		if (width >= 768) {
			setDraggable = true;
		} else {
			setDraggable = false;
		}

		$(window).resize(function () {
			width = viewportSize.getWidth();
			if (width >= 768) {
				setDraggable = true;
			} else {
				setDraggable = false;
			}
		});

		let mapOptions = {
			zoom: mp_zoom,
			center: new google.maps.LatLng(
				googleCenter[0],
				googleCenter[1]
			),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			draggable: setDraggable,
			zoomControl: true, // Enable zoom control
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_CENTER // Position the zoom control
			}
		};

		map = new google.maps.Map(
			map_canvas,
			mapOptions
		);

		let svgIcon = {
			url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
				<svg width="24px" height="36px" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg">
					<path d="M12.3875636,0 C18.4864493,0 24,4.84555218 24,11.7801663 C24,13.0645835 23.6583652,14.4426743 22.9750957,15.9144385 L15.0961692,33.8410547 C14.4246008,35.2803516 13.5217323,36 12.3875636,36 C11.2533949,36 10.2526107,35.2803516 9.38521109,33.8410547 L0.826089236,15.9144385 C0.275363079,14.8451017 0,13.467011 0,11.7801663 C3.13558686e-16,4.09896332 6.28867781,0 12.3875636,0 Z M12.5,18 C15.5375661,18 18,15.5375661 18,12.5 C18,9.46243388 15.5375661,7 12.5,7 C9.46243388,7 7,9.46243388 7,12.5 C7,15.5375661 9.46243388,18 12.5,18 Z"
						fill="#007785" />
				</svg>
			`),
			scaledSize: new google.maps.Size(24, 36),
			anchor: new google.maps.Point(12, 36)
		};

		let marker = new google.maps.Marker({
			position: new google.maps.LatLng(mp_lat, mp_lng),
			map: map,
			icon: svgIcon,
			animation: google.maps.Animation.DROP,
		});

		// Keeps the pin in the centre of the map on window resize
		let center;
		map_canvas.addEventListener('idle', (evt => {
			center = map.getCenter();
		}));

		window.addEventListener('resize', function () {
			map.setCenter(center);
		});
		// Keeps the pin in the centre of the map on window resize
	}
	// Google Single Property Map.
	// ------------------------------ //



	// ------------------------------ //
	// Google 'Our Guide' Map - Multiple Pins
	if ($('#things_cpt_map').length > 0) {
		// Initialise Google Map with multiple pins

		// Initialise Google Map.
		// var mapElement = document.getElementById('things_cpt_map');
		// mp_initialize_multi(mapElement);

		// Add event listener to category buttons
		$('.filter-btn').on('click', function () {
			const selectedCategory  = $(this).attr('id'); // Get the button's ID (category slug)
			const markersByCategory = mapElement.markersByCategory;
			const markerCluster     = mapElement.markerCluster;

			// Remove all markers from the cluster
			markerCluster.clearMarkers();

			// Add the relevant markers back to the cluster
			if (selectedCategory === 'all') {
				// Show all markers
				const allMarkers = Object.values(markersByCategory).flat();
				markerCluster.addMarkers(allMarkers);
			} else {
				// Show only markers for the selected category
				if (markersByCategory[selectedCategory]) {
					markerCluster.addMarkers(markersByCategory[selectedCategory]);
				}
			}
		});

	}

	function mp_initialize_multi(mapElement) {

		let mp_map, mp_lat, mp_lng, mp_zoom, mp_centre, latlngbounds, LatLngList = [];

		mp_lat       = $(mapElement).data('center-location-lat');
		mp_lng       = $(mapElement).data('center-location-lng');
		mp_zoom      = $(mapElement).data('center-location-zoom');
		mp_centre    = new google.maps.LatLng(mp_lat, mp_lng);

		var locations = getLocations( mapElement );

		var mp_touch = false;
		if( $('html.no-touch').length > 0 ) { mp_touch = true; }
		// checks to see if mobile or desktop (screen touch available), then enable / disable map drag

		var mp_touch = true;

		var mp_mapOptions = {
			zoom: mp_zoom,
			minZoom: 1,
			maxZoom: 18,
			center: mp_centre,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			draggable: mp_touch,
			mapId: "6512f85f6830f2f2", // Map ID is required for advanced markers.
			zoomControl: true, // Enable zoom control.
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_CENTER // Adjust position as desired.
			}
		};

		mp_map = new google.maps.Map(document.getElementById('things_cpt_map'), mp_mapOptions);

		/**
		 * Add all attraction markers to map.
		 */
		addAttractionMarkers( mapElement, locations, mp_map );

		/**
		 * Bound the map to display all pins.
		 */
		// Add hotel center map to LatLngList.
		LatLngList.push(new google.maps.LatLng(mp_lat, mp_lng));

		// Loop points of interest and add lat lng to LatLngList.
		$.each(
			locations,
			function () {
				LatLngList.push( new google.maps.LatLng( this.lat, this.lng ) );
			}
		);

	}

	function getLocations(mapElement) {

		let locations = [];
		let markers   = mapElement.getAttribute('data-locations');

		// Check if the markers are a string and parse them if necessary
		if (typeof markers === 'string') {

			// Check if the string is valid JSON
			try {
				markers = JSON.parse(markers);
			} catch (error) {
				console.error("Error parsing JSON:", error);
			}
		}

		$.each(markers, function (index, marker) {

			locations.push({
				name: marker.title,
				url: marker.url,
				subtitle: marker.subtitle,
				internal_link: marker.internal_link,
				external_link: marker.external_link,
				categories: marker.categories,
				content: marker.content,
				thumbnail: marker.thumbnail,
				lat: marker.map_location.lat,
				lng: marker.map_location.lng
			});
		});

		return locations;
	}

	function addAttractionMarkers(mapElement, locations, mp_map) {

		const markersByCategory = {};
		const markers = [];
		const infoWindow = new google.maps.InfoWindow();

		$.each(locations, function () {
			const position = {
				lat: parseFloat(this.lat),
				lng: parseFloat(this.lng)
			};

			// Determine the fill color for the category
			let fillColor = '#FF0000'; // Default color
			if (this.categories && this.categories.length > 0) {
				const primaryCategory = this.categories[0];
				fillColor = {
					'food-drink': '#DB48AE',
					'activities': '#35B2A9',
					'culture-attractions': '#277be9',
					'beaches': '#F98048',
					'events': '#7E2C58',
				}[primaryCategory] || fillColor; // Default fallback
			}

			// Create the custom SVG icon
			const svgIcon = getCategorySVGIcon(fillColor);

			// Create the marker
			const marker = new google.maps.marker.AdvancedMarkerElement({
				position: position,
				map: mp_map,
				content: svgIcon, // Use the SVG as the content
				title: this.name,
			});

			// Add a click listener to the marker
			marker.addListener('click', () => {
				// Set the content for the info window
				infoWindow.setContent(`
					<div class="info-window">
						${this.thumbnail ? `<figure><img src="${this.thumbnail}" alt="${this.name}"></figure>` : ''}
						<div class="info-content">
							${this.subtitle ? `<h6>${this.subtitle}</h6>` : ''}
							<h3>${this.name}</h3>
							${this.content ? `<div class="content">${this.content}</div>` : ''}
							${this.internal_link || this.external_link ? `<div class="links">
								${this.internal_link ? `<div class="internal"><a href="${this.url}">Read more</a></div>` : ''}
								${this.external_link ? `<div class="external"><a href="${this.external_link}" target="_blank">Visit Site</a></div>` : ''}
							</div>` : ''}
						</div>
					</div>
				`);

				// Open the info window at the marker
				infoWindow.open(mp_map, marker);
			});

			// Add the marker to the markers array
			markers.push(marker);

			// Add marker to the appropriate category
			(this.categories || []).forEach((category) => {
				if (!markersByCategory[category]) {
					markersByCategory[category] = [];
				}
				markersByCategory[category].push(marker);
			});

		});

		// Initialize MarkerClusterer with all markers
		const markerCluster = new MarkerClusterer({
			map: mp_map,
			markers: markers,
			options: { gridSize: 60, maxZoom: 15 },
		});

		// Attach markersByCategory and markerCluster to the mapElement for filtering
		mapElement.markersByCategory = markersByCategory;
		mapElement.markerCluster     = markerCluster;

	}

	function getCategorySVGIcon(fillColor) {
		const svgString = `
			<svg width="24px" height="36px" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg">
				<path d="M12.3875636,0 C18.4864493,0 24,4.84555218 24,11.7801663 C24,13.0645835 23.6583652,14.4426743 22.9750957,15.9144385 L15.0961692,33.8410547 C14.4246008,35.2803516 13.5217323,36 12.3875636,36 C11.2533949,36 10.2526107,35.2803516 9.38521109,33.8410547 L0.826089236,15.9144385 C0.275363079,14.8451017 0,13.467011 0,11.7801663 C3.13558686e-16,4.09896332 6.28867781,0 12.3875636,0 Z M12.5,18 C15.5375661,18 18,15.5375661 18,12.5 C18,9.46243388 15.5375661,7 12.5,7 C9.46243388,7 7,9.46243388 7,12.5 C7,15.5375661 9.46243388,18 12.5,18 Z"
					fill="${fillColor}" />
			</svg>
		`;

		// Convert SVG string to a DOM node
		const template = document.createElement('template');
		template.innerHTML = svgString.trim(); // .trim() removes unnecessary whitespace
		return template.content.firstChild; // Return the first child (the <svg> element)
	}
	// Google 'Our Guide' Map - Multiple Pins
	// ------------------------------ //

    // Define Google Maps callback function initMap on the global window object so that Google Maps API can find it.
    window.initMap = function() {
        const mpMap = document.getElementById('mp_map_canvas');
        if (mpMap) {
            mp_initialize(mpMap);
        }
        const thingsMap = document.getElementById('things_cpt_map');
        if (thingsMap) {
            mp_initialize_multi(thingsMap);
        }
	};


	let width = window.innerWidth; // Use Web API.
	let height = window.innerHeight; // Use Web API.

	// Global Window Object

	$(function () {

		console.log("Width: " + width + ", Height: " + height);

		/**
		 * Masonry Grid, Memory Wall
		 * https://chatgpt.com/share/676a8538-3f2c-800a-8736-bf2e11c12b44
		 * Masonry lazy loading fix.
		 * Do not use image attribute loading="lazy" with Masonry, it fails in chrome due to intrinsic size.
		 *
		 */
		if ($('section.masonry-content-wall').length > 0) {

			var $grid = $('.masonry-grid').masonry({
				itemSelector: '.grid-item',
				columnWidth: '.grid-item-width',
				percentPosition: true
			});

			// Ensure images are loaded before Masonry layout
			$grid.imagesLoaded().progress(function () {
				// console.log('Image loaded, refreshing Masonry layout');
				$grid.masonry('layout');
			});

			// Handle lazy-loaded images
			$grid.on('lazyloaded', function (e) {
				// 'lazysizes' pkg fires this event when an image is lazy-loaded.
				// console.log('Lazyloaded image detected, refreshing Masonry layout');
				$grid.masonry('layout');
			});


		}



		/**
		 * Start
		 * Desktop menu vertical slide-in panel
		 * Mouse and keyboard interactions - accessibility.
		 */
		const menuItems = $("#mega-menu > li[aria-haspopup='true']");
		const topLevelLinks = $("#mega-menu > li > a");

		menuItems.each(function () {
			const menuItem = $(this);
			const link = menuItem.find("> a");
			const submenu = menuItem.find(".sub-menu");

			// Show submenu on focus or mouseenter
			const showSubMenu = () => {
				menuItem.attr("aria-expanded", "true");
				submenu.attr("aria-hidden", "false").stop().slideDown(200);
			};

			// Hide submenu on mouseleave
			const hideSubMenu = () => {
				menuItem.attr("aria-expanded", "false");
				submenu.attr("aria-hidden", "true").stop().slideUp(200);
			};

			// Handle hover events
			menuItem.on("mouseenter", showSubMenu);
			menuItem.on("mouseleave", hideSubMenu);

			// Keep submenu open while focusing within it
			submenu.on("focusin", showSubMenu);
			submenu.on("focusout", function (e) {
				// Check if focus has moved outside the menu entirely
				if (!menuItem.has(e.relatedTarget).length) {
					hideSubMenu();
				}
			});

			// Allow keyboard navigation within the submenu
			submenu.find("a").on("keydown", function (e) {
				const links = submenu.find("a");
				const index = links.index(this);

				switch (e.key) {
					case "ArrowDown": // Move to the next item
						e.preventDefault();
						links.eq((index + 1) % links.length).focus();
						break;
					case "ArrowUp": // Move to the previous item
						e.preventDefault();
						links.eq((index - 1 + links.length) % links.length).focus();
						break;
					case "Escape": // Close the submenu
						e.preventDefault();
						hideSubMenu();
						link.focus();
						break;
				}
			});

			// Open submenu on focus of the top-level link
			link.on("focus", showSubMenu);

			// Close submenu when focus leaves the menu entirely
			link.on("blur", function (e) {
				if (!menuItem.has(e.relatedTarget).length) {
					hideSubMenu();
				}
			});

			// Add horizontal navigation for top-level menu items
			topLevelLinks.on("keydown", function (e) {
				const index = topLevelLinks.index(this);

				switch (e.key) {
					case "ArrowRight": // Move to the next top-level item
						e.preventDefault();
						topLevelLinks.eq((index + 1) % topLevelLinks.length).focus();
						break;
					case "ArrowLeft": // Move to the previous top-level item
						e.preventDefault();
						topLevelLinks.eq((index - 1 + topLevelLinks.length) % topLevelLinks.length).focus();
						break;
					case "ArrowDown": // Open submenu on ArrowDown
						e.preventDefault();
						const submenuLinks = $(this).parent().find(".sub-menu a");
						if (submenuLinks.length > 0) {
							submenuLinks.first().focus();
						}
						break;
				}
			});
		});
		/**
		 * Desktop menu vertical slide-in panel
		 * Finish.
		 */




		if ($('body.single-property .property-content .show-more').length > 0) {

			// Set up click event handler
			$('.property-content button.show-more').on('click', function () {

				// console.log('.property-content .show-more');

				var $hiddenContent = $(this).siblings('.hidden-paragraphs');
				var $button = $(this);

				var targetOffset = $('.property-content').children().first().offset().top;
				$('html, body').animate({ scrollTop: targetOffset - 40 }, 400);

				// Function to be executed after 400 milliseconds
				setTimeout(function() {
					// Code to execute after the delay

					if ($hiddenContent.is(':visible')) {
						// For hiding: capture the offset before hiding.
						$hiddenContent.slideUp(function() {
							$button.text('More');
							$button.attr('aria-expanded', 'false');
							$button.attr('aria-label', 'Show more');
						});
					} else {
						// For showing: first slide down, then scroll.
						$hiddenContent.slideDown(function() {
							$button.text('Less');
							$button.attr('aria-expanded', 'true');
							$button.attr('aria-label', 'Show less');
						});
					}
				}, 400);

			});

		}




		if ($('body.single-property .property-particulars .show-more').length > 0) {

			$('.property-particulars button.show-more').on('click', function () {

				console.log('.property-particulars button.show-more');

				var $hiddenContent = $(this).siblings('.hidden-particulars');
				var $button = $(this);

				var targetOffset = $('.property-particulars').children().first().offset().top;
				$('html, body').animate({ scrollTop: targetOffset - 40 }, 400);

				// Function to be executed after 400 milliseconds
				setTimeout(function() {
					// Code to execute after the delay

					if ($hiddenContent.is(':visible')) {
						// For hiding: capture the offset before hiding.
						$hiddenContent.slideUp(function() {
							$button.text('More');
							$button.attr('aria-expanded', 'false');
							$button.attr('aria-label', 'Show more');
						});
					} else {
						// For showing: first slide down, then scroll.
						$hiddenContent.slideDown(function() {
							$button.text('Less');
							$button.attr('aria-expanded', 'true');
							$button.attr('aria-label', 'Show less');
						});
					}
				}, 400);

			});

		}



		if ($('body.single-property .property-notes .show-more').length > 0) {

			var $button = $('.property-notes .show-more');
			var $notesContainer = $('.property-notes-container');

			$button.on('click', function () {

				// console.log('.property-notes .show-more');

				var targetOffset = $('.property-notes').children().first().offset().top;
				$('html, body').animate({ scrollTop: targetOffset - 40 }, 400);

				var expanded = $(this).attr('aria-expanded') === 'true';

				$(this).attr('aria-expanded', !expanded);
				$notesContainer.attr('aria-hidden', expanded);

				if (!expanded) {
					$(this).text('Less');
					$notesContainer.animate({ 'max-height': $notesContainer[0].scrollHeight + 'px' }, 400);
				} else {
					$(this).text('More');
					$notesContainer.animate({ 'max-height': '120px' }, 400);
				}
			});

		}



		if ($('body.single-property .property-reviews .show-more').length > 0) {

			var $button = $('.property-reviews .show-more');
			var $reviews = $('.property-review-container .review.hidden');

			$button.on('click', function () {

				// console.log('.property-reviews .show-more');

				var targetOffset = $('.property-reviews').children().first().offset().top;
				$('html, body').animate({ scrollTop: targetOffset - 40 }, 400);

				var expanded = $(this).attr('aria-expanded') === 'true';

				if (expanded) {
					// Collapse reviews
					$reviews.slideUp(function () {
						$reviews.addClass('hidden');
					});
					$button.attr('aria-expanded', 'false').text('More').attr('aria-label', 'Show more reviews');
				} else {
					// Expand reviews
					$reviews.removeClass('hidden').hide().slideDown();
					$button.attr('aria-expanded', 'true').text('Less').attr('aria-label', 'Show fewer reviews');
				}
			});

		}



		if ($('.hero .hero-slideshow').length > 0) {

			var $slider = $('.hero-slideshow--slides');

			// Show the slides after loading, prevents Content Layout Shift.
			$slider.on("init", function ( event, slick ) {
				$slider.css({
					visibility: "visible",
					height: "100%",
				});
			});

			// Initialize Slick Slider
			$slider.slick({
				autoplay: true,          // Enable autoplay
				autoplaySpeed: 5000,      // Set autoplay speed in milliseconds
				speed: 600,              // Transition speed between slides
				fade: true,			  // Fade effect between slides
				arrows: false,           // Hide arrows by default
				dots: false,              // Optionally show dots for navigation
				infinite: true,          // Loop slides
				slidesToShow: 1,         // Show one slide at a time
				slidesToScroll: 1,       // Scroll one slide at a time
			});

			// Conditionally show arrows if more than one slide
			if ($slider.find('.slick-slide').length > 1) {
				$slider.slick('slickSetOption', 'arrows', true, true);
			}

		}







		if ($('#landing_page_properties .cottage-block .slider').length > 0) {

			var $slider = $('.cottage-block .slider');

			// Show the slides after loading, prevents Content Layout Shift.
			$slider.on("init", function ( event, slick ) {
				$slider.css({
					visibility: "visible",
					height: "100%",
				});
			});

			// Initialize Slick Slider
			$slider.slick({
				autoplay: true,          // Enable autoplay
				autoplaySpeed: 5000,      // Set autoplay speed in milliseconds
				speed: 600,              // Transition speed between slides
				fade: true,			  // Fade effect between slides
				arrows: false,           // Hide arrows by default
				dots: false,              // Optionally show dots for navigation
				infinite: true,          // Loop slides
				slidesToShow: 1,         // Show one slide at a time
				slidesToScroll: 1,       // Scroll one slide at a time
			});

			// Conditionally show arrows if more than one slide
			if ($slider.find('.slick-slide').length > 1) {
				$slider.slick('slickSetOption', 'arrows', true, true);
			}

		}




		/**
		 * Start
		 * Results or Landing Page Properties, sorting.
		 */
		$(document).on('click', '.sorting-container .sort-title', function () {
			$('.sorting-container .sorting').toggleClass('show');
		});


		$(document).on('click', '.sorting-container .sort-panel .item', function () {

			var $this = $(this).data('sort');

			if ($this === 'alphabet-high') {

				change_sort_panel($(this).text());

				if ($('.results-container').length > 0) {
					sort_by_alphabet_high();
				}

			}
			else if ($this === 'alphabet-low') {

				change_sort_panel($(this).text());

				if ($('.results-container').length > 0) {
					sort_by_alphabet_low();
				}

			}
			else if ($this === 'number-high') {

				change_sort_panel($(this).text());

				if ($('.results-container').length > 0) {
					sort_by_number_high();
				}

			}
			else if ($this === 'number-low') {

				change_sort_panel($(this).text());

				if ( $('.results-container').length > 0 ) {
					sort_by_number_low();
				}

			}
			else if ($this === 'sleeps-high') {

				change_sort_panel($(this).text());

				if ( $('.results-container').length > 0 ) {
					sort_by_sleeps_high();
				}

			}
			else if ($this === 'sleeps-low') {

				change_sort_panel($(this).text());

				if ( $('.results-container').length > 0 ) {
					sort_by_sleeps_low();
				}

			}

		});

		/**
		 * Change the Sort by panel title.
		 * @param string $new_title - The text to change the panel title to.
		 */
		function change_sort_panel($new_title) {
			$('.sorting-container .sort-title span').text($new_title);

			// Close the sorting options available.
			$('.sorting-container .sorting').toggleClass('show');
		}

		/**
		 * Sort by alphabetically Z-A.
		 * Search Results Page.
		 * Sort each .results-container by alphabet (Z–A)
		 */
		function sort_by_alphabet_high() {
			$('.results-container').each(function() {
				const $container = $(this);
				// grab all the blocks in this container
				const $blocks = $container.find('.sort-alphabetically .cottage-block');

				// detach, sort, and re-append
				$blocks
				.detach()
				.sort((a, b) => {
					const at = $(a).data('sort-title').toUpperCase();
					const bt = $(b).data('sort-title').toUpperCase();
					// reverse order: Z → A
					return (at < bt) ? 1 : (at > bt) ? -1 : 0;
				})
				.appendTo($container.find('.sort-alphabetically'));
			});
		}

		/**
		 * Sort by alphabetically A-Z.
		 * Search Results Page.
		 * Sort each .results-container by alphabet (A–Z).
		 */
		function sort_by_alphabet_low() {
			$('.results-container').each(function() {
			const $container = $(this);
			const $blocks = $container.find('.sort-alphabetically .cottage-block');

			$blocks
				.detach()
				.sort((a, b) => {
				const at = $(a).data('sort-title').toUpperCase();
				const bt = $(b).data('sort-title').toUpperCase();
				// normal order: A → Z
				return (at > bt) ? 1 : (at < bt) ? -1 : 0;
				})
				.appendTo($container.find('.sort-alphabetically'));
			});
		}

		/**
		 * Sort by number High-Low.
		 * Search Results Page.
		 * @param {string} type
		 */
		function sort_by_number_high() {
			let this_type = '.results-container';

			var number_options = $(this_type + ' .sort-numerically .cottage-block');
			number_options.detach().sort(function(a,b) {
				var at = $(a).data('sort-price');
				var bt = $(b).data('sort-price');
				return (at < bt)?1:((at > bt)?-1:0);
			});
			number_options.appendTo(this_type + ' .sort-numerically');
		}

		/**
		 * Sort by number Low-High.
		 * Search Results Page.
		 * @param {string} type
		 */
		function sort_by_number_low() {
			let this_type = '.results-container';

			var number_options = $(this_type + ' .sort-numerically .cottage-block');
			number_options.detach().sort(function(a,b) {
				var at = $(a).data('sort-price');
				var bt = $(b).data('sort-price');
				return (at > bt)?1:((at < bt)?-1:0);
			});
			number_options.appendTo(this_type + ' .sort-numerically');
		}

		/**
		 * Sort by sleeps High-Low.
		 * Search Results Page.
		 * Sort each .results-container by “sleeps” (High → Low).
		 */
		function sort_by_sleeps_high() {
			$('.results-container').each(function() {
			const $container = $(this);
			const $blocks = $container.find('.sort-sleeps .cottage-block');

			$blocks
				.detach()
				.sort((a, b) => {
				// parse the sleep counts as numbers
				const at = parseFloat($(a).data('sort-sleeps'));
				const bt = parseFloat($(b).data('sort-sleeps'));
				// high → low
				return bt - at;
				})
				.appendTo($container.find('.sort-sleeps'));
			});
		}

		/**
		 * Sort by sleeps Low-High.
		 * Search Results Page.
		 * Sort each .results-container by “sleeps” (Low → High).
		 */
		function sort_by_sleeps_low() {
			$('.results-container').each(function() {
			const $container = $(this);
			const $blocks = $container.find('.sort-sleeps .cottage-block');

			$blocks
				.detach()
				.sort((a, b) => {
				// parse the sleep counts as numbers
				const at = parseFloat($(a).data('sort-sleeps'));
				const bt = parseFloat($(b).data('sort-sleeps'));
				// low → high
				return at - bt;
				})
				.appendTo($container.find('.sort-sleeps'));
			});
		}
		// Finish.




		if ($('.slideshow.contentStacked').length > 0) {

			// For each instance of the slideshow, apply the slick logic
			$('.slideshow.contentStacked').each(function() {
				var $slickElement = $(this);

				// Show the slides after loading, prevents Content Layout Shift.
				$slickElement.on("init", function (event, slick) {
					$slickElement.css({
						visibility: "visible",
						height: "100%",
					});
				});

				// Initialize slick for this specific element
				$slickElement.slick({
					dots: false,
					speed: 600,
					slidesToShow: 1,
					autoplay: false,
					autoplaySpeed: 4000,
					arrows: true,
					prevArrow: $slickElement.parent().siblings('.slideshow-buttons').find('.slick-prev'), // Set the previous arrow for this slideshow
					nextArrow: $slickElement.parent().siblings('.slideshow-buttons').find('.slick-next'), // Set the next arrow for this slideshow
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								autoplay: true // Enable autoplay for screens below 768px
							}
						}
					]
				});

				// Optional: If you want to add any click handlers for specific slides
				// $slickElement.on('click', '.slick-slide', function (e) {
				//     e.stopPropagation();
				//     var index = $(this).data("slick-index");
				//     if ($slickElement.slick('slickCurrentSlide') !== index) {
				//         $slickElement.slick('slickGoTo', index);
				//     }
				// });
			});
		}


		if ($('#property_hero_gallery .slideshow').length > 0) {

			var $slickElement = $('#property_hero_gallery .slideshow');

			// Show the slides after loading, prevents Content Layout Shift.
			$slickElement.on("init", function (event, slick) {
				$slickElement.css({
					visibility: "visible",
					height: "100%",
				});
			});

			// Initialize slick for this specific element
			$slickElement.slick({
				slidesToShow: 2, // Default for larger screens
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 4000,
				speed: 600,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1 // 1 image for screens below 768px
						}
					}
				]
			});

			// Use jQuery to get the data-images attribute from the slideshow div
			const imageDataString = $('.slideshow').attr('data-images');

			// Parse the JSON string into a JavaScript array
			const imageDataArray = JSON.parse(imageDataString);

			// Initialize the options object and set the dataSource using the parsed array
			const options = {
				dataSource: imageDataArray.map(image => ({
					src: image.src,
					width: image.width,
					height: image.height,
					alt: image.alt
				}))
			};

			// You can now use the options object as needed, for example in a slideshow plugin initialization
			// console.log(options);

			// Event handler for opening the gallery with the first image
			$('#open_gallery').on('click', function () {
				options.index = 0; // Open with the first image (index 0)
				const pswp = new PhotoSwipe(options);
				pswp.init(); // Initializing PhotoSwipe core and adding it to DOM
			});


			// Ensure button exists before adding event listener
			// $('button.gallery').on('click', function () {
			$slickElement.on('click', '.slick-slide', function () {

				// console.log('Button clicked, opening gallery');

				// Get clicked image index
				var index = $(this).data('slick-index');

				options.index = index; // defines start slide index
				const pswp = new PhotoSwipe(options);
				pswp.init(); // initializing PhotoSwipe core adds it to DOM

			});

		}


		if ($('.slideshow.contentScrolled').length > 0) {

			// For each instance of the slideshow, apply the slick logic
			$('.slideshow.contentScrolled').each(function() {
				var $slickElement = $(this);

				// Show the slides after loading, prevents Content Layout Shift.
				$slickElement.on("init", function (event, slick) {
					$slickElement.css({
						visibility: "visible",
						height: "100%",
					});
				});

				// Initialize slick for this specific element
				$slickElement.slick({
					dots: false,
					speed: 600,
					slidesToShow: 1,
					autoplay: false,
					autoplaySpeed: 5000,
					arrows: true,
					prevArrow: $slickElement.parent().siblings('.slideshow-buttons').find('.slick-prev'), // Set the previous arrow for this slideshow
					nextArrow: $slickElement.parent().siblings('.slideshow-buttons').find('.slick-next'), // Set the next arrow for this slideshow
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								autoplay: true // Enable autoplay for screens below 768px
							}
						}
					]
				});

				// Optional: If you want to add any click handlers for specific slides
				// $slickElement.on('click', '.slick-slide', function (e) {
				//     e.stopPropagation();
				//     var index = $(this).data("slick-index");
				//     if ($slickElement.slick('slickCurrentSlide') !== index) {
				//         $slickElement.slick('slickGoTo', index);
				//     }
				// });
			});
		}



		// Horizontal scroll buttons
		// https://chatgpt.com/c/67431b76-9a94-800a-a470-4f9e6021f3b6
		if ($('.scroll-wrapper').length > 0) {

			const $prevBtn = $('.prev-btn');
			const $nextBtn = $('.next-btn');
			const $scrollContainer = $('.properties > .row');
			const $childDiv = $('.properties > .row > div'); // Target the inner div elements

			// Function to calculate the scroll amount dynamically
			let scrollAmount = $childDiv.outerWidth(true); // Includes margins, if any

			const updateScrollAmount = () => {
				scrollAmount = $childDiv.outerWidth(true);
			};

			// Update button visibility and state
			const updateButtonVisibility = function () {
				const scrollLeft = $scrollContainer.scrollLeft();
				const maxScrollLeft = $scrollContainer[0].scrollWidth - $scrollContainer.outerWidth();

				// Show/Hide buttons based on scroll position
				$prevBtn.toggle(scrollLeft > 0); // Show only if not at the start
				$nextBtn.toggle(scrollLeft < maxScrollLeft); // Show only if not at the end
			};

			// Scroll left
			$prevBtn.on('click', function () {
				$scrollContainer.animate({
					scrollLeft: $scrollContainer.scrollLeft() - scrollAmount,
				}, 300, updateButtonVisibility); // Update button visibility after scroll
			});

			// Scroll right
			$nextBtn.on('click', function () {
				$scrollContainer.animate({
					scrollLeft: $scrollContainer.scrollLeft() + scrollAmount,
				}, 300, updateButtonVisibility); // Update button visibility after scroll
			});

			// Recalculate scrollAmount and update button visibility on resize
			$(window).on('resize', function () {
				updateScrollAmount();
				updateButtonVisibility();
			});

			// Attach the updateButtonVisibility function to the scroll event
			$scrollContainer.on('scroll', updateButtonVisibility);

			// Initial setup
			updateScrollAmount();
			updateButtonVisibility(); // Set the correct button visibility on load

		}




		/**
		 * Search form input field - Autocomplete for locations and property names.
		 */
		if ($('#tbCountries').length > 0) {

			/**
			 * This variable helps to prevent the redirection to the search results page when the user selects a location, when on a criteria landing page.
			 * i.e.: /collections/sleeps-4/
			 */
			let locationSearch = false;

			/**
			 * Autocomplete with custom icons
			 * https://chatgpt.com/c/67165a21-aa78-800a-a015-5b9395850eea
			 */
			$("#tbCountries").autocomplete({
				source: Countries,
				minLength: 0,  // So it shows suggestions even when typing nothing.
				focus: function (event, ui) {
					$(this).val(ui.item.label);
					return false;
				},
				select: function (event, ui) {
					$(this).val(ui.item.label);

					// console.log($(this).val(ui.item.label));
					// console.log('*** SELECT: #tbCountries: ' + $('#tbCountries').val());

					// If the selected item's icon is 'fa-home', redirect to the corresponding URL.
					if (ui.item.icon === 'fa-home') {
						// console.log(ui.item.url);
						$('.search-form .form-element button#search-submit').addClass('disabled').prop('disabled', true);
						window.location.href = ui.item.url;
					}
					// else {
					// 	// console.log('*** SELECT: #tbCountries: ' + $('#tbCountries').val());
					// 	$('.search-form .form-element button#search-submit').removeClass('disabled').prop('disabled', false);
					// }

					/**
					 * Single landing page.
					 */
					if ($('body.single-landing_page').length > 0) {

						/**
						 * Single landing page with NO location slug.
						 */
						if (
							$('#advanced-search-results').data('location-slug') === ''
							||
							locationSearch === true
						) {

							/**
							 * First run through, data('location-slug') is empty.
							 * First run through we set data('location-slug') to the selected location.
							 * Subsequent runs through, locationSearch is true.
							 * This prevents a page redirect to search results page when making a location selection on a criteria landing page.
							 * i.e.: /collections/sleeps-4/
							 */

							/**
							 * Filtering of location can happen here.
							 * Only filter cottages by location if the selected item is not a property name.
							 */

							if (ui.item.icon !== 'fa-home') {
								filterCottagesByLocation();
							}

							let selectedLocation = $('#tbCountries').val();

							$('#advanced-search-results').data('location', selectedLocation);
							$('#advanced-search-results').data('location-slug', selectedLocation.toLowerCase());

							locationSearch = true;
						}

						/**
						 * Single landing page WITH location slug.
						 */
						if (
							$('#advanced-search-results').data('location-slug') !== ''
							&&
							locationSearch === false
						) {

							/**
							 * We redirect to the search results page with the selected location.
							 *
							 * The purpose of this is that if the user is on a town landing page 'Falmouth', and the user changes the town through the filters panel, we do not want the town landing page to show properties of a different location to the town landing page.
							 * Hence, we redirect to the search results page with the selected location.
							 */

							/**
							 * FLAG
							 * Pass across any / all filter parameters in the URL.
							 * then on the search results page, perform the filtering.
							 */

							// Get the nonce from HTML element.
							let nonce = $('#search_filters #_wpnonce').val();

							// Construct the URL with the nonce and selected location
							let url = new URL('/search-results/', window.location.origin);

							// Add the nonce to the URL.
							url.searchParams.append('_wpnonce', nonce);

							// Add the selected location to the URL.
							url.searchParams.append('chc_locations', ui.item.label);

							// Add default arrival date to the URL - empty value.
							url.searchParams.append('chc_arrival_date', '');

							// Add search date extension - empty value.
							// url.searchParams.append('chc_extend_date', '1');

							// Get the number of guests from the filter panel.
							url.searchParams.append('chc_a', $('#chc_adults').val());
							url.searchParams.append('chc_c', $('#chc_children').val());
							url.searchParams.append('chc_i', $('#chc_infants').val());

							if ('-1' !== $('#chc_pets').val()) {
								/**
								 * Only add chc_dog_friendly to the URL if the value is not -1 (Pets N/A).
								 */

								// Get the value of pets from the filter panel.
								url.searchParams.append('chc_dog_friendly', $('#chc_pets').val() === '0' ? 'off' : 'on');

							}

							if ('-1' !== $('#chc_rooms').val()) {
								/**
								 * Only add chc_rooms to the URL if the value is not -1 (Any Bedrooms).
								 */

								// Get the value of bedrooms from the filter panel.
								url.searchParams.append('chc_rooms', $('#chc_rooms').val());

							}

							if ('-1' !== $('#chc_bathrooms').val()) {
								/**
								 * Only add chc_bathrooms to the URL if the value is not -1 (Any Bedrooms).
								 */

								// Get the value of bedrooms from the filter panel.
								url.searchParams.append('chc_bathrooms', $('#chc_bathrooms').val());

							}

							// Add the number of guests to the URL.
							var totalGuests = parseInt($('#chc_adults').val()) + parseInt($('#chc_children').val()) + parseInt($('#chc_infants').val());
							url.searchParams.append('chc_guests', totalGuests);


							// Get the values of the Price Range Slider - lower.
							// let lowerHandleValue = $('#range-slider .noUi-handle-lower').attr('aria-valuetext').replace('£', '');
							// url.searchParams.append('chc_price_lower', lowerHandleValue);

							// // Get the values of the Price Range Slider - upper.
							// let rangeSliderValue = $('#range-slider .noUi-handle-upper').attr('aria-valuetext').replace('£', '');
							// url.searchParams.append('chc_price_upper', rangeSliderValue);


							// console.log('*** SELECT: #tbCountries: ' + lowerHandleValue);
							// console.log('*** SELECT: #tbCountries: ' + rangeSliderValue);

							// Redirect to the constructed URL
							window.location.href = url.toString();
						}
					}

					/**
					 * Search Results page.
					 */
					if (
						$('body.search-results').length > 0
					) {

						// console.log('*** SELECT: #tbCountries: body.search-results');

						/**
						 * We redirect to the search results page with the selected location.
						 *
						 * The purpose of this is that when on a search results page, if the user changes the location through the filters panel, we want to show properties of the selected location, we do this by redirecting to the search results page again but now with the new selected location.
						 */

						// Get the nonce from HTML element.
						let nonce = $('#search_filters #_wpnonce').val();

						// Construct the URL with the nonce and selected location
						let url = new URL('/search-results/', window.location.origin);

						// Add the nonce to the URL.
						url.searchParams.append('_wpnonce', nonce);

						// Add the selected location to the URL.
						url.searchParams.append('chc_locations', ui.item.label);

						let dateRange = '';

						/**
						 * Check if the arrival date is not empty.
						 */
						if ($('#advanced-search-results').data('arrival-date') !== 0) {
							// Setup the arrival and departure dates.

							// 8+Feb+2025+—+15+Feb+2025
							let searchDate = $('#advanced-search-results').data('arrival-date');
							let searchLength = $('#advanced-search-results').data('nights');

							let startDate = new Date(searchDate);
							let endDate   = new Date(startDate);
							endDate.setDate(startDate.getDate() + searchLength);

							let options = { day: 'numeric', month: 'short', year: 'numeric' };
							let formattedStartDate = startDate.toLocaleDateString('en-GB', options);
							let formattedEndDate = endDate.toLocaleDateString('en-GB', options);

							dateRange = `${formattedStartDate} — ${formattedEndDate}`;
						}

						// Add default arrival date to the URL.
						url.searchParams.append('chc_arrival_date', dateRange);

						// Add search date extension - empty value.
						url.searchParams.append('chc_extend_date', $('#plus_minus input[name="chc_extend_date"]:checked').val());

						// Get the number of guests from the filter panel.
						url.searchParams.append('chc_a', $('#chc_adults').val());
						url.searchParams.append('chc_c', $('#chc_children').val());
						url.searchParams.append('chc_i', $('#chc_infants').val());

						if ('-1' !== $('#chc_pets').val()) {
							/**
							 * Only add chc_dog_friendly to the URL if the value is not -1 (Pets N/A).
							 */

							// Get the value of pets from the filter panel.
							url.searchParams.append('chc_dog_friendly', $('#chc_pets').val() === '0' ? 'off' : 'on');

						}

						if ('-1' !== $('#chc_rooms').val()) {
							/**
							 * Only add chc_rooms to the URL if the value is not -1 (Any Bedrooms).
							 */

							// Get the value of bedrooms from the filter panel.
							url.searchParams.append('chc_rooms', $('#chc_rooms').val());

						}

						if ('-1' !== $('#chc_bathrooms').val()) {
							/**
							 * Only add chc_bathrooms to the URL if the value is not -1 (Any Bedrooms).
							 */

							// Get the value of bedrooms from the filter panel.
							url.searchParams.append('chc_bathrooms', $('#chc_bathrooms').val());

						}

						// Add the number of guests to the URL.
						var totalGuests = parseInt($('#chc_adults').val()) + parseInt($('#chc_children').val()) + parseInt($('#chc_infants').val());
						url.searchParams.append('chc_guests', totalGuests);

						// Get the values of the Price Range Slider - lower / higher.
						if ($('#range-slider .noUi-handle').length > 0) {

							let lowerHandleValue = $('.noUi-handle-lower').attr('aria-valuetext').replace('£', '');
							let rangeSliderValue = $('.noUi-handle-upper').attr('aria-valuetext').replace('£', '');

							let lowerHandleValueMin = Math.floor($('.noUi-handle-lower').attr('aria-valuemin'));
							let upperHandleValueMax = Math.floor($('.noUi-handle-upper').attr('aria-valuemax'));

							if (
								lowerHandleValueMin !== parseInt(lowerHandleValue)
							) {
								url.searchParams.append('chc_price_lower', lowerHandleValue);
							}

							if (
								upperHandleValueMax !== parseInt(rangeSliderValue)
							) {
								url.searchParams.append('chc_price_upper', rangeSliderValue);
							}
						}

						// Redirect to the constructed URL
						window.location.href = url.toString();

					}

					return false;
				},
				change: function (event, ui) {
					let inputVal = $(this).val();

					// console.log('*** CHANGE: #tbCountries: ' + inputVal);

					// Find a match in the Countries array based on the input value.
					let matchedItem = Countries.find(item => item.label.toLowerCase() === inputVal.toLowerCase());

					if (matchedItem && matchedItem.icon === 'fa-home') {
						// If the matched item has the 'fa-home' icon, redirect to its URL.
						window.location.href = matchedItem.url;
					} else if (!matchedItem) {
						// If no match is found, clear the input field.
						$(this).val('');
					}
				}
			}).data("ui-autocomplete")._renderItem = function (ul, item) {
				return $("<li>")
					.append("<div><i class=\'fa " + item.icon + "\'></i> " + item.label + "</div>")
					.appendTo(ul);
			};

			// Trigger (bind) the autocomplete on focus to show all options
			$("#tbCountries").focus(function () {
				$(this).autocomplete("search", "");
			});

			// Trigger (bind) the autocomplete on click to show all options
			$("#tbCountries").on("click", function () {
				$(this).autocomplete("search", "");
			});
			// End - Autocomplete


			// Initial functionality that should not be lost
			// Add your existing jQuery logic here, if any







			/**
			 * Function to get dates from #advanced-search-results.
			 * We pass the selected date range to the calendar input field.
			 * The dates are then displayed in the calendar and the input field.
			 *
			 * @returns dates object with range and display properties.
			 */
			function getDateRangeFromElement() {
				const searchResultsSection = $('#advanced-search-results');

				if (!searchResultsSection.length) {
					return null; // Return null if the section doesn't exist
				}

				// Get the data attributes
				const arrivalDate = searchResultsSection.data('arrival-date');
				const nights = parseInt(searchResultsSection.data('nights'), 10);

				if (!arrivalDate || isNaN(nights) || nights <= 0) {
					return null; // Return null if arrival date or nights are invalid
				}

				// Calculate the end date based on the arrival date and number of nights
				const startDate = new Date(arrivalDate);
				const endDate = new Date(startDate);
				endDate.setDate(startDate.getDate() + nights);

				// Format the dates to YYYY-MM-DD
				const formatDate = (date) => date.toISOString().split('T')[0];

				return {
					range: `${formatDate(startDate)}:${formatDate(endDate)}`, // For calendar initialization
					display: `${startDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })} — ${endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}`, // For display
				};
			}

			// Update summary text based on inputs
			function updateSummaryAndHiddenGuests() {
				var adults = parseInt($('#adults').val());
				var children = parseInt($('#children').val());
				var infants = parseInt($('#infants').val());
				var pets = $('#pets').is(':checked') ? 'with Pets' : 'No Pets';

				var totalGuests = adults + children + infants;

				var summaryText = 'Guests (' + totalGuests + '), ' + pets;
				$('.summary').text(summaryText);

				// Update hidden input with total guest count
				$('#hidden-guests').val(totalGuests);
			}

			/**
			 * Update the property counter based on the selected filters.
			 * @param {string} selectedLocation
			 */
			function updatePropertyCounter(selectedLocation = null) {

				// console.log('updatePropertyCounter');

				// Count the number of visible properties.
				let property_counter = $('#cottage-blocks-container .cottage-block').not('.hide-pets, .hide-guests, .hide-amenities, .hide-bedrooms, .hide-bathrooms, .hide-price').length;

				// If a location is selected and it's not 'all-properties', filter the properties by location.
				if (selectedLocation !== '' && selectedLocation !== null && selectedLocation !== 'all-properties') {

					let potential_properties = $('#cottage-blocks-container .cottage-block').not('.hide-pets, .hide-guests, .hide-amenities, .hide-bedrooms, .hide-bathrooms, .hide-price').filter(function () {

						const locations = $(this).data('locations').split(',');
						return locations.includes(selectedLocation);
					});

					property_counter = potential_properties.length;

				}

				// Update the property counter text.
				$('#results-title .success #results-count').text(property_counter + (property_counter === 1 ? ' property' : ' properties'));
				$('#results-title .success #results-count').data('count', property_counter);

				if (property_counter === 0) {
					// We have no results.

					$('#advanced-search-results-no-results').show();
					$('#advanced-search-results-yes-results').hide();
				} else {
					// We have 1 or more results.

					// console.log('updatePropertyCounter - results found' );

					/**
					 * This is a delay to allow SlickSlider to initialize properly before showing the properties.
					 * Properties need to have a height before the slider can be initialized.
					 * Therefore we can only show all the properties after the slider has been initialized.
					 */
					setTimeout(function() {
						// console.log("1 second delay completed.");
						// Do these after the filteration is complete.
						$('#advanced-search-results-checking').hide();
						$('#advanced-search-results-no-results').hide();
						$('#advanced-search-results-yes-results').show().addClass('display');

						/**
						 * Check if property archive list has a date value.
						 * If it does, we need to show the price range slider.
						 * If it does not, we do not need to show the price range slider.
						 * This is to prevent the price range slider from showing on the location only search (no date search).
						 */
						if ($('#advanced-search-results').data('arrival-date') !== 0) {
							// Setup the price range slider.
							get_prices_range();
						}

					}, 1000); // 1000 milliseconds = 1 second

					// $('#advanced-search-results-no-results').hide();
					// $('#advanced-search-results-yes-results').show().addClass('display');
				}

			}


			/**
			 * Search results page or landing page properties.
			 * Filter cottages by location.
			 */
			function filterCottagesByLocation() {

				// console.log('filterCottagesByLocation');

				/**
				 * Get the selected location from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				if (selectedLocation) {
					$('.cottage-block').hide(); // Hide all cottage blocks first.

					// Show only the blocks that match the selected location.
					$('.cottage-block').filter(function () {
						const locations = $(this).data('locations').split(',');
						return locations.includes(selectedLocation);
					}).show(); // Show matching blocks

					updatePropertyCounter(selectedLocation);

				} else {
					$('.cottage-block').show(); // Show all if no location is selected
				}


			}

			// Function to calculate total guests and filter cottages by Guests.
			function filterCottagesByGuests() {

				// console.log('filterCottagesByGuests');

				/**
				 * Get the selected location from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				// Get the values from all selects and calculate the total guests
				const adults   = parseInt($('#chc_adults').val()) || 0;
				const children = parseInt($('#chc_children').val()) || 0;
				const infants  = parseInt($('#chc_infants').val()) || 0;

				// Total guests (infants not counted towards sleeps, depending on logic)
				const totalGuests = adults + children + infants;

				// Filter cottage blocks based on total guests
				$('.cottage-block').each(function () {
					const sleeps = parseInt($(this).data('sort-sleeps')) || 0;

					if (sleeps >= totalGuests) {
						$(this).removeClass('hide-guests'); // Show cottages that can accommodate the total guests
						// cottage_block_counter++;
					} else {
						$(this).addClass('hide-guests'); // Hide cottages that can't accommodate
					}
				});

				// Set the properties returned count.
				updatePropertyCounter(selectedLocation);
				// $('#results-title .success #results-count').text(cottage_block_counter + (cottage_block_counter > 1 ? ' properties' : ' property'));
				// $('#results-title .success #results-count').data('count', cottage_block_counter);
			}

			// Function to filter cottages by Pets.
			function filterCottagesByPets() {

				// console.log('filterCottagesByPets');

				/**
				 * Get the selected location from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				// Get the values pets dropdown.
				const pets = parseInt($('#chc_pets').val());

					// Filter cottage blocks based on total guests
				$('.cottage-block').each(function () {
					const this_block_dogs = parseInt($(this).data('pets'));

					if (pets !== -1) {

						if (this_block_dogs === pets) {
							$(this).removeClass('hide-pets'); // Show cottages that allow pets.
						} else {
							$(this).addClass('hide-pets'); // Hide cottages that do not allow pets.
						}

					} else {
						$(this).removeClass('hide-pets');
					}
				});

				// Set the properties returned count.
				updatePropertyCounter(selectedLocation);
				// $('#results-title .success #results-count').text(cottage_block_counter + (cottage_block_counter > 1 ? ' properties' : ' property'));
				// $('#results-title .success #results-count').data('count', cottage_block_counter);
			}

			// Function to filter cottages by Bedrooms.
			function filterCottagesByBedrooms() {

				// console.log('filterCottagesByBedrooms');

				/**
				 * Get the selected bedrooms from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				// Get the selected number of bedrooms from the dropdown
				const selectedBedrooms = parseInt($('#chc_rooms').val()) || 0;

				// Loop through each .cottage-block to apply the filtering logic
				$('.cottage-block').each(function () {
					const bedrooms = parseInt($(this).data('bedrooms')) || 0;

					// Add or remove the appropriate classes based on the condition
					if (bedrooms < selectedBedrooms) {
						$(this).addClass('hide-bedrooms'); // Hide cottages that don't match the condition
					} else {
						$(this).removeClass('hide-bedrooms'); // Show cottages that match the condition
					}
				});

				// Set the properties returned count.
				updatePropertyCounter(selectedLocation);
				// $('#results-title .success #results-count').text(cottage_block_counter + (cottage_block_counter > 1 ? ' properties' : ' property'));
				// $('#results-title .success #results-count').data('count', cottage_block_counter);
			}

			// Function to filter cottages by Bathrooms.
			function filterCottagesByBathrooms() {

				// console.log('filterCottagesByBathrooms');

				/**
				 * Get the selected bathrooms from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				// Get the selected number of bathrooms from the dropdown
				const selectedBathrooms = parseInt($('#chc_bathrooms').val()) || 0;

				// Loop through each .cottage-block to apply the filtering logic
				$('.cottage-block').each(function () {
					const bathrooms = parseInt($(this).data('bathrooms')) || 0;

					// Add or remove the appropriate classes based on the condition
					if (bathrooms < selectedBathrooms) {
						$(this).addClass('hide-bathrooms'); // Hide cottages that don't match the condition
					} else {
						$(this).removeClass('hide-bathrooms'); // Show cottages that match the condition
					}
				});

				// Set the properties returned count.
				updatePropertyCounter(selectedLocation);
				// $('#results-title .success #results-count').text(cottage_block_counter + (cottage_block_counter > 1 ? ' properties' : ' property'));
				// $('#results-title .success #results-count').data('count', cottage_block_counter);
			}

			// Function to filter cottages by Amenities.
			function filterCottagesByAmenity(selectedAmenities) {

				// console.log('filterCottagesByAmenities');
				// console.log(selectedAmenities);

				/**
				 * Get the selected location from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				let selectedLocation       = $('#tbCountries').val().toLowerCase();
				selectedLocation = selectedLocation.replace(/\s+/g, '-');

				// get data-amenities attribute from #advanced-search-results
				// let amenities = $('#advanced-search-results').data('amenities');

				// check all.cottage-block elements (data-filters) for selectedAmenities
				$('#cottage-blocks-container .cottage-block').each(function () {

					// get data-amenities attribute from each .cottage-block element
					let cottageFilters = $(this).data('filters');

					// check if selectedAmenities are in cottageFilters
					if (selectedAmenities.every(amenity => cottageFilters.includes(amenity))) {
						$(this).removeClass('hide-amenities'); // Show cottages that have all selected amenities
					} else {
						$(this).addClass('hide-amenities'); // Hide cottages that do not have all selected amenities
					}
				});

				updatePropertyCounter(selectedLocation);

			}



			// Get the date range from the URL
			const dateData = getDateRangeFromElement();

			// If dateData is valid, set the input field value
			if (dateData && dateData.display) {
				$('#calendar-input').val(dateData.display);

				// We need to show +-3 days buttons only when the user has dates selected.
				// This will show the +/- buttons on the search results page with dates.
				$('#search_filters .where-wrapper .element-calendar-extended').show();
			}




			if ($('#advanced-search-results, #wp-advanced-search').length > 0) {

				/**
				 * Vanilla Calendar Pro
				 * This code initializes the Vanilla Calendar plugin with multiple date selection.
				 * https://chatgpt.com/c/6718c2be-d39c-800a-ab83-d6014dc06519
				 * https://chatgpt.com/c/6718c8da-4e5c-800a-9712-c7e21129ab3b
				 *
				 * Documentation for 2.9.10:
				 * https://v2.vanilla-calendar.pro/
				 */
				const options = {
					input: true,
					type: 'multiple',
					months: 2,
					jumpMonths: 1,
					jumpToSelectedDate: true,
					settings: {
						selected: {
							dates: dateData && dateData.range ? [dateData.range] : [], // Use the date range from the section
						},
						range: {
							disablePast: true, // Disable past dates
						},
						selection: {
							day: 'multiple-ranged', // Multiple ranged selection
						},
						visibility: {
							daysOutside: false, // Hide days outside the current month
							today: true, // Show today's date
							theme: 'light', // Light theme
							positionToInput: 'center', // Position the calendar below the input
						},
					},
					actions: {
						changeToInput: function (e, self) {
							const inputElem = $(self.HTMLInputElement);

							if (!inputElem.length) return;

							const formatDate = (date) => {
								const options = { day: 'numeric', month: 'short', year: 'numeric' };
								return new Date(date).toLocaleDateString('en-GB', options);
							};

							if (self.selectedDates.length > 1) {
								// Two dates selected.

								// $('.search-form .form-element button#search-submit').removeClass('disabled').prop('disabled', false);

								// Sort dates
								self.selectedDates.sort((a, b) => new Date(a) - new Date(b));

								// Update input value with the selected range
								inputElem.val(`${formatDate(self.selectedDates[0])} — ${formatDate(self.selectedDates[self.selectedDates.length - 1])}`);

								/**
								 * Single landing page or search results page.
								 */
								if (
									$('body.single-landing_page').length > 0
									||
									$('body.search-results').length > 0
								) {

									// console.log(self.selectedDates);

									/**
									 * Redirect to search results page with the selected date range.
									 * Also consider the selected location and number of guests.
									 * Get these from #advanced-search-results
									 */

									// Get the nonce from HTML element.
									let nonce = $('#search_filters #_wpnonce').val();

									// Construct the URL with the nonce and selected location
									let url = new URL('/search-results/', window.location.origin);

									// Add the nonce to the URL.
									url.searchParams.append('_wpnonce', nonce);

									// Add the selected location to the URL.
									url.searchParams.append('chc_locations', $('#advanced-search-results').data('location'));

									// Add the selected date range to the URL.
									url.searchParams.append('chc_arrival_date', `${formatDate(self.selectedDates[0])} — ${formatDate(self.selectedDates[self.selectedDates.length - 1])}`);

									// Add search date extension - empty value.
									url.searchParams.append('chc_extend_date', $('#plus_minus input[name="chc_extend_date"]:checked').val());

									// Get the number of guests from the filter panel.
									url.searchParams.append('chc_a', $('#chc_adults').val());
									url.searchParams.append('chc_c', $('#chc_children').val());
									url.searchParams.append('chc_i', $('#chc_infants').val());

									if ('-1' !== $('#chc_pets').val()) {
										/**
										 * Only add chc_dog_friendly to the URL if the value is not -1 (Pets N/A).
										 */

										// Get the value of pets from the filter panel.
										url.searchParams.append('chc_dog_friendly', $('#chc_pets').val() === '0' ? 'off' : 'on');
									}

									if ('-1' !== $('#chc_rooms').val()) {
										/**
										 * Only add chc_rooms to the URL if the value is not -1 (Any Bedrooms).
										 */

										// Get the value of bedrooms from the filter panel.
										url.searchParams.append('chc_rooms', $('#chc_rooms').val());

									}

									if ('-1' !== $('#chc_bathrooms').val()) {
										/**
										 * Only add chc_bathrooms to the URL if the value is not -1 (Any Bedrooms).
										 */

										// Get the value of bedrooms from the filter panel.
										url.searchParams.append('chc_bathrooms', $('#chc_bathrooms').val());

									}

									// Add the number of guests to the URL.
									var totalGuests = parseInt($('#chc_adults').val()) + parseInt($('#chc_children').val()) + parseInt($('#chc_infants').val());
									url.searchParams.append('chc_guests', totalGuests);

									let chc_amenities = [];
									$('.amenities-wrapper input[type="checkbox"]:checked').each(function () {
										chc_amenities.push($(this).val());
									});
									chc_amenities = chc_amenities.join(',');
									url.searchParams.append('chc_amenities', chc_amenities);



									// Get the values of the Price Range Slider - lower / higher.
									if ($('#range-slider .noUi-handle').length > 0) {

										let lowerHandleValue = $('.noUi-handle-lower').attr('aria-valuetext').replace('£', '');
										let rangeSliderValue = $('.noUi-handle-upper').attr('aria-valuetext').replace('£', '');

										let lowerHandleValueMin = Math.floor($('.noUi-handle-lower').attr('aria-valuemin'));
										let upperHandleValueMax = Math.floor($('.noUi-handle-upper').attr('aria-valuemax'));

										if (
											lowerHandleValueMin !== parseInt(lowerHandleValue)
										) {
											url.searchParams.append('chc_price_lower', lowerHandleValue);
										}

										if (
											upperHandleValueMax !== parseInt(rangeSliderValue)
										) {
											url.searchParams.append('chc_price_upper', rangeSliderValue);
										}
									}

									// Redirect to the constructed URL
									window.location.href = url.toString();

								}

							} else if (self.selectedDates.length === 1) {
								// One date selected.

								// Update input with single date
								inputElem.val(formatDate(self.selectedDates[0]));

							} else {
								// Clear input
								inputElem.val('');
							}
						},
					},
				};

				// Initialize the calendar
				const calendarInput = new VanillaCalendar('#calendar-input', options);
				calendarInput.init();
				// End - Vanilla Calendar Pro



				/**
				 * Search Results page.
				 */
				if (
					$('body.search-results').length > 0
				) {

					/**
					 * If the user selects a extended date, we need to update the URL with the selected date range
					 * and redirect to the search results page.
					 * This is done by adding a change event listener to the radio buttons.
					 * The selected date range is then passed to the search results page.
					 */
					$('.element-calendar-extended #plus_minus').on('change', 'input[name="chc_extend_date"]', function(){

						// Get the selected value from the +-3 days radio buttons.
						var newVal = this.value;

						// console.log('Extend date changed to:', newVal);

						/**
						 * Format the date range to be added to the URL.
						 */
						// 8+Feb+2025+—+15+Feb+2025
						let searchDate = $('#advanced-search-results').data('arrival-date');
						let searchLength = $('#advanced-search-results').data('nights');

						let startDate = new Date(searchDate);
						let endDate   = new Date(startDate);
						endDate.setDate(startDate.getDate() + searchLength);

						let options = { day: 'numeric', month: 'short', year: 'numeric' };
						let formattedStartDate = startDate.toLocaleDateString('en-GB', options);
						let formattedEndDate = endDate.toLocaleDateString('en-GB', options);

						let dateRange = `${formattedStartDate} — ${formattedEndDate}`;

						/**
						 * Redirect to search results page with the selected date range.
						 * Also consider the selected location and number of guests.
						 * Get these from #advanced-search-results
						 */

						// Get the nonce from HTML element.
						let nonce = $('#search_filters #_wpnonce').val();

						// Construct the URL with the nonce and selected location
						let url = new URL('/search-results/', window.location.origin);

						// Add the nonce to the URL.
						url.searchParams.append('_wpnonce', nonce);

						// Add the selected location to the URL.
						url.searchParams.append('chc_locations', $('#advanced-search-results').data('location'));

						// Add the selected date range to the URL.
						url.searchParams.append('chc_arrival_date', dateRange);

						if ( '0' !== newVal ) {
							// Add search date extension - empty value.
							url.searchParams.append('chc_extend_date', $('#plus_minus input[name="chc_extend_date"]:checked').val());
						}

						// Get the number of guests from the filter panel.
						url.searchParams.append('chc_a', $('#chc_adults').val());
						url.searchParams.append('chc_c', $('#chc_children').val());
						url.searchParams.append('chc_i', $('#chc_infants').val());

						if ('-1' !== $('#chc_pets').val()) {
							/**
							 * Only add chc_dog_friendly to the URL if the value is not -1 (Pets N/A).
							 */

							// Get the value of pets from the filter panel.
							url.searchParams.append('chc_dog_friendly', $('#chc_pets').val() === '0' ? 'off' : 'on');
						}

						if ('-1' !== $('#chc_rooms').val()) {
							/**
							 * Only add chc_rooms to the URL if the value is not -1 (Any Bedrooms).
							 */

							// Get the value of bedrooms from the filter panel.
							url.searchParams.append('chc_rooms', $('#chc_rooms').val());

						}

						if ('-1' !== $('#chc_bathrooms').val()) {
							/**
							 * Only add chc_bathrooms to the URL if the value is not -1 (Any Bedrooms).
							 */

							// Get the value of bedrooms from the filter panel.
							url.searchParams.append('chc_bathrooms', $('#chc_bathrooms').val());

						}

						// Add the number of guests to the URL.
						var totalGuests = parseInt($('#chc_adults').val()) + parseInt($('#chc_children').val()) + parseInt($('#chc_infants').val());
						url.searchParams.append('chc_guests', totalGuests);

						let chc_amenities = [];
						$('.amenities-wrapper input[type="checkbox"]:checked').each(function () {
							chc_amenities.push($(this).val());
						});
						chc_amenities = chc_amenities.join(',');
						url.searchParams.append('chc_amenities', chc_amenities);



						// Get the values of the Price Range Slider - lower / higher.
						if ($('#range-slider .noUi-handle').length > 0) {

							let lowerHandleValue = $('.noUi-handle-lower').attr('aria-valuetext').replace('£', '');
							let rangeSliderValue = $('.noUi-handle-upper').attr('aria-valuetext').replace('£', '');

							let lowerHandleValueMin = Math.floor($('.noUi-handle-lower').attr('aria-valuemin'));
							let upperHandleValueMax = Math.floor($('.noUi-handle-upper').attr('aria-valuemax'));

							if (
								lowerHandleValueMin !== parseInt(lowerHandleValue)
							) {
								url.searchParams.append('chc_price_lower', lowerHandleValue);
							}

							if (
								upperHandleValueMax !== parseInt(rangeSliderValue)
							) {
								url.searchParams.append('chc_price_upper', rangeSliderValue);
							}
						}

						// Redirect to the constructed URL
						window.location.href = url.toString();
					});
				}
			}


			// Toggle summary-panel on summary click or Enter/Space key press
			$('.summary').on('click keydown', function(event) {
				// Allow toggling the panel via keyboard
				if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))) {
					event.preventDefault(); // Prevent default behavior for Enter/Space

					var $panel = $('.summary-panel');
					var isPanelVisible = $panel.hasClass('visible');

					if (isPanelVisible) {
						$panel.removeClass('visible');
					} else {
						$panel.addClass('visible');
						// Focus on the first input (adults) when panel opens
						$('#adults').focus();
					}
				}
			});

			// Handle Enter key to toggle checkbox
			$('#pets').on('keydown', function(event) {
				if (event.key === 'Enter') {
					event.preventDefault(); // Prevent form submission if in a form
					$(this).prop('checked', !$(this).is(':checked')); // Toggle the checkbox
					updateSummaryAndHiddenGuests(); // Update the summary when toggling via Enter key
				}
			});

			// Close summary-panel when clicking outside of it
			$(document).on('click', function(event) {
				var $panel = $('.summary-panel');
				var $summary = $('.summary');

				// Check if the clicked element is neither the panel nor the summary
				if (!$panel.is(event.target) && $panel.has(event.target).length === 0 && !$summary.is(event.target)) {
					$panel.removeClass('visible'); // Close the panel
				}
			});

			// Close summary-panel when pressing Esc key
			$(document).on('keydown', function(event) {
				if (event.key === 'Escape') {
					$('.summary-panel').removeClass('visible');
				}
			});

			// Update the value in the input field
			$('.plus, .minus').on('click', function() {
				var target = $(this).data('target');
				var $input = $('#' + target);
				var currentVal = parseInt($input.val());

				// Increment or decrement the value
				if ($(this).hasClass('plus')) {
					$input.val(currentVal + 1);
				} else if ($(this).hasClass('minus') && currentVal > 0) {
					$input.val(currentVal - 1);
				}

				updateSummaryAndHiddenGuests();
			});

			// Update summary when pets checkbox is changed
			$('#pets').on('change', function() {
				updateSummaryAndHiddenGuests();
			});

			// Initialize summary on page load
			updateSummaryAndHiddenGuests();


			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the guests dropdown value (filters panel) on page load.
			 *
			 */
			if ($('#search_filters #hidden-guests').length > 0) {

				/**
				 * If guests data attributes exist, update the hidden input field
				 * and select the appropriate options in the dropdowns.
				 */
				const guestsAdults   = $('#advanced-search-results').data('guests-a');
				const guestsChildren = $('#advanced-search-results').data('guests-c');
				const guestsInfants  = $('#advanced-search-results').data('guests-i');
				const bedrooms       = $('#advanced-search-results').data('bedrooms');
				const bathrooms      = $('#advanced-search-results').data('bathrooms');

				if (guestsAdults) {
					// Update the visible dropdowns.
					$('#chc_adults').val(guestsAdults); // Set the selected value for adults.
				}

				if (guestsChildren) {
					// Update the visible dropdowns.
					$('#chc_children').val(guestsChildren); // Set the selected value for children.

				}

				if (guestsInfants) {
					// Update the visible dropdowns.
					$('#chc_infants').val(guestsInfants); // Set the selected value for infants.
				}

				if (bedrooms) {
					// Update the visible dropdowns.
					$('#chc_rooms').val(bedrooms); // Set the selected value for bedrooms.
				}

				if (bathrooms) {
					// Update the visible dropdowns.
					$('#chc_bathrooms').val(bathrooms); // Set the selected value for bathrooms.
				}



				// Bind the change event to all select elements
				$('#chc_adults, #chc_children, #chc_infants').on('change', function () {
					filterCottagesByGuests();
				});

				// Initial filter when the page loads
				// filterCottagesByGuests();

			}

			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the pets dropdown value (filters panel) on page load.
			 */
			if ($('#search_filters #chc_pets').length > 0) {

				// console.log('#search_filters #chc_pets');

				const pets = $('#advanced-search-results').data('dogs');

				if ( 1 === pets ) {
					// Update the visible dropdowns.
					$('#chc_pets').val(1); // Set the selected value for adults.
				}

				if ( 0 === pets ) {
					// Update the visible dropdowns.
					$('#chc_pets').val(0); // Set the selected value for adults.
				}

				if ( -1 === pets ) {
					// Update the visible dropdowns.
					$('#chc_pets').val(-1); // Set the selected value for adults.
				}



				// Bind the change event to all select elements
				$('#chc_pets').on('change', function () {
					filterCottagesByPets();
				});
			}

			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the bedrooms dropdown value (filters panel) on page load.
			 */
			if ($('#search_filters #chc_rooms').length > 0) {

				// console.log('#search_filters #chc_rooms');

				const bedrooms = $('#advanced-search-results').data('bedrooms');

				if ( 'on' === bedrooms ) {
					// Update the visible dropdowns.
					$('#chc_rooms').val(1); // Set the selected value for adults.
				}

				// Bind the change event to all select elements
				$('#chc_rooms').on('change', function () {
					filterCottagesByBedrooms();
				});

			}

			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the bathrooms dropdown value (filters panel) on page load.
			 */
			if ($('#search_filters #chc_bathrooms').length > 0) {

				// console.log('#search_filters #chc_bathrooms');

				const bathrooms = $('#advanced-search-results').data('bathrooms');

				if ( 'on' === bathrooms ) {
					// Update the visible dropdowns.
					$('#chc_bathrooms').val(1); // Set the selected value for adults.
				}

				// Bind the change event to all select elements
				$('#chc_bathrooms').on('change', function () {
					filterCottagesByBathrooms();
				});

			}


			// See function get_prices_range for more details.
			let pricesRangeInitialized = false;

			function get_prices_range() {

				// console.log('*** get_prices_range ***');

				/**
				 * Prevent multiple initializations of the price range slider.
				 * Only occurs on the Landing pages.
				 */
				if (pricesRangeInitialized) {
					// console.log('get_prices_range already initialized');
					return;
				}
				pricesRangeInitialized = true;

				/**
				 * Get the selected bedrooms from the dropdown.
				 * Replace spaces with hyphens to match the data attribute.
				 * Convert to lowercase for case-insensitive matching.
				 */
				// let selectedLocation       = $('#tbCountries').val().toLowerCase();
				// selectedLocation = selectedLocation.replace(/\s+/g, '-');



				// Step 1: Get all `.cottage-block` elements and extract `data-sort-price`
				const prices = $('.cottage-block')
					.map(function () {
					return parseFloat($(this).data('sort-price'));
					})
					.get()
					.filter(price => !isNaN(price)); // Ensure we only get numeric values

				// Step 2: Sort prices in ascending order
				prices.sort((a, b) => a - b);

				// Step 3: Calculate the lowest and highest prices and round
				let lowestPrice = Math.floor(prices[0] / 100) * 100; // Round down to nearest £100
				let highestPrice = Math.ceil(prices[prices.length - 1] / 100) * 100; // Round up to nearest £100

				// Step 4: Initialize noUiSlider with the lowest and highest prices
				const $slider = $('#range-slider');
				const $minValue = $('#min-value');
				const $maxValue = $('#max-value');

				// Helper function to get query parameters from the URL
				const getQueryParam = (param) => {
					const urlParams = new URLSearchParams(window.location.search);
					return urlParams.get(param);
				};

				// Get price parameters from the URL
				let priceLower = getQueryParam('chc_price_lower');
				let priceUpper = getQueryParam('chc_price_upper');

				// Fallback to default prices if parameters are not available
				priceLower = priceLower ? parseInt(priceLower, 10) : lowestPrice;
				priceUpper = priceUpper ? parseInt(priceUpper, 10) : highestPrice;

				noUiSlider.create($slider[0], {
					start: [priceLower, priceUpper], // Start at lowest and highest prices
					connect: true,                     // Highlight range between handles
					range: {
						min: lowestPrice,               // Minimum value
						max: highestPrice                // Maximum value
					},
					step: 100,                         // Step increments of £100
					tooltips: true,                    // Show tooltips
					format: {
						to: (value) => `£${Math.round(value)}`,
						from: (value) => Number(value.replace('£', ''))
					}
				});

				$('.price-wrapper').show(); // Show the price range slider.

				// Function to update the displayed values and filter `.cottage-block`
				const updateBlocksVisibility = (values) => {

					// Get the selected minimum and maximum values
					// Parse the values to remove "£" and convert them to integers
					const minSelected = parseInt(values[0].replace('£', ''), 10);
					const maxSelected = parseInt(values[1].replace('£', ''), 10);

					// Update the displayed minimum and maximum values
					$minValue.text(`£${minSelected}`);
					$maxValue.text(`£${maxSelected}`);

					// Show/hide blocks based on the selected range
					$('.cottage-block').each(function () {
						const price = parseFloat($(this).data('sort-price'));

						if (price < minSelected || price > maxSelected) {
							$(this).addClass('hide-price');
						} else {
							$(this).removeClass('hide-price');
						}
					});

					// Set the properties returned count.
					// updatePropertyCounter(selectedLocation);
					updatePropertyCounter();
				};

				// Listen for slider updates and filter `.cottage-block`
				$slider[0].noUiSlider.on('update', function (values) {
					updateBlocksVisibility(values);
				});
			};

			// Make function globally accessible.
			// Disables eslint warning on function not being used (when they are called from other files).
			window.get_prices_range = get_prices_range;



			if ($('#advanced-search-results.landing-page').length > 0) {

				// Update the property counter based on the selected filters.
				// Execute the function on page load.
				updatePropertyCounter(null);
				// updatePropertyCounter([$('#advanced-search-results.landing-page').data('location')]);
			}



			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the pets dropdown value (filters panel) on page load.
			 */
			if ($('#search_filters .amenities-wrapper').length > 0) {

				// Bind the change event to all checkboxes within the amenities-wrapper
				$(document).on('change', '.amenities-wrapper input[type="checkbox"]', function () {
					const selectedAmenities = $('.amenities-wrapper input[type="checkbox"]:checked').map(function () {
						return $(this).val();
					}).get();

					filterCottagesByAmenity(selectedAmenities);
				});



				/**
				 * Show / Hide search filters on mobile
				 */
				const $searchFiltersInner = $("#search_filters_inner");
				const $searchFiltersClose = $("#search_filters_close");
				const $searchFiltersCloseLower = $("#search_filters_close_lower");

				const updateVisibility = () => {
					const isMobile = $(window).width() < 768;
					const isFiltersOpen = $searchFiltersInner.is(":visible"); // Check if filters are currently open

					if (isMobile) {
						if (!isFiltersOpen) { // Only hide if it's already hidden
							$searchFiltersInner.hide().attr("aria-hidden", "true");
						}
						$searchFiltersClose.show().attr("aria-expanded", isFiltersOpen ? "true" : "false").text(isFiltersOpen ? "Close Filters" : "Open Filters");
						$searchFiltersCloseLower.hide(); // Always hidden on page load
					} else {
						$searchFiltersInner.show().attr("aria-hidden", "false");
						$searchFiltersClose.hide().removeAttr("aria-expanded");
						$searchFiltersCloseLower.hide(); // Hidden on desktop
					}
				};


				const toggleSearchFilters = () => {
					const isHidden = $searchFiltersInner.is(":hidden");
					$searchFiltersInner.toggle(isHidden).attr("aria-hidden", !isHidden ? "false" : "true");
					$searchFiltersClose
						.attr("aria-expanded", isHidden ? "true" : "false")
						.attr("aria-label", isHidden ? "Close search filters" : "Open search filters")
						.text(isHidden ? "Close Filters" : "Open Filters"); // Update button text

					// Toggle visibility of #search_filters_close_lower
					if (isHidden) {
						$searchFiltersCloseLower.show();
					} else {
						$searchFiltersCloseLower.hide();
					}
				};

				const closeSearchFilters = () => {
					$searchFiltersInner.hide().attr("aria-hidden", "true");
					$searchFiltersClose
						.attr("aria-expanded", "false")
						.attr("aria-label", "Open search filters")
						.text("Open Filters"); // Reset button text
					$searchFiltersCloseLower.hide(); // Hide the lower button when filters are closed
				};

				// Event listeners
				$searchFiltersClose.on("click", toggleSearchFilters);
				$searchFiltersCloseLower.on("click", closeSearchFilters);
				$(window).on("resize", updateVisibility);

				// Initial setup on page load
				updateVisibility();

			}

		}


		/**
		 * Check all .cottage-block elements on the page,
		 * if they are already in localStorage, add the 'favourite' class.
		 */
		var storedProperties = JSON.parse(localStorage.getItem('properties')) || [];

		// console.log(storedProperties);

		if ($('.cottage-block').length > 0) {

			// console.log('Checking for Favourites');

			$('.cottage-block').each(function () {

				let cottageClass = $(this).attr('class');
				let regex        = /unit-id-(\d+)/;

				if (cottageClass) {
					// Strip 'unit-id-' from the id
					let strippedClass = cottageClass.match(regex);
					// Check if the strippedClass exists in localStorage

					if (storedProperties.includes(parseInt(strippedClass[1], 10))) {
						// Highlight the matching cottage
						// console.log('Favourite Found:', strippedClass[1]);
						$(this).find('.cottages-single-favourite').addClass('favourite');
					}
				}
			});
		}



		/**
		 * When on the single property page,
		 * check if the property is already in localStorage,
		 * then add the 'favourite' class to the parent element.
		 */
		if ($('#single-property-wrapper').length > 0) {

			// console.log('Checking for Favourites 2');

			$('#single-property-wrapper article.property').each(function () {
				let propertyClass = $(this).attr('class');
				let regex = /post-(\d+)/;

				if (propertyClass) {
					// Extract the property ID
					let propertyIdMatch = propertyClass.match(regex);
					if (propertyIdMatch) {
						let propertyId = parseInt(propertyIdMatch[1], 10);

						// Check if the property ID exists in localStorage
						if (storedProperties.includes(propertyId)) {
							// Add the 'favourite' class to the .cottages-single-favourite element
							$(this).find('.cottages-single-favourite').addClass('favourite');
						}
					}
				}
			});
		}



		/**
		 * Add to Favourites.
		 * Also check each property if same WP_ID,
		 * then add the 'favourite' class to the parent element.
		 */
		$(document).on('click', '.add-favourite', function (e) {
			e.preventDefault();

			let $this_clicked_element = $(this);

			let property_value = $this_clicked_element.data('property');

			// Retrieve existing property values from localStorage
			let storedProperties = JSON.parse(localStorage.getItem('properties')) || [];

			// Ensure 'properties' in localStorage is always an array and allow multiple values
			if (!Array.isArray(storedProperties)) {
				storedProperties = [storedProperties];
			}

			// Add the new property value to the array if it's not already there
			if (!storedProperties.includes(property_value)) {
				storedProperties.push(property_value);
				localStorage.setItem('properties', JSON.stringify(storedProperties));

				$this_clicked_element.parent().addClass('favourite');
				// $this_clicked_element.hide();
				// $this_clicked_element.siblings('.remove-favourite').show();

				$('.cottage-block').each(function () {

					let cottageClass = $(this).attr('class');
					let regex        = /unit-id-(\d+)/;

					if (cottageClass) {
						// Strip 'unit-id-' from the id
						let strippedClass = cottageClass.match(regex);
						// Check if the strippedClass exists in localStorage

						if (storedProperties.includes(parseInt(strippedClass[1], 10))) {
							// Highlight the matching cottage
							// console.log('Favourite Found:', strippedClass[1]);
							$(this).find('.cottages-single-favourite').addClass('favourite');
						}
					}
				});

			}

		});

		/**
		 * Remove from Favourites.
		 * Also check each property if same WP_ID,
		 * then remove the 'favourite' class from the parent element.
		 */
		$(document).on('click', '.remove-favourite', function (e) {
			e.preventDefault();

			let $this_clicked_element = $(this);

			let property_value = $this_clicked_element.data('property');

			// Retrieve existing property values from localStorage
			let storedProperties = JSON.parse(localStorage.getItem('properties')) || [];

			// Ensure 'properties' in localStorage is always an array
			if (!Array.isArray(storedProperties)) {
				storedProperties = [storedProperties];
			}

			// Remove the property value from the array if it exists
			if (storedProperties.includes(property_value)) {
				storedProperties = storedProperties.filter(item => item !== property_value);
				localStorage.setItem('properties', JSON.stringify(storedProperties));

				$this_clicked_element.parent().removeClass('favourite');
				// $this_clicked_element.hide();
				// $this_clicked_element.siblings('.add-favourite').show();

				$('.cottage-block').each(function () {

					let cottageClass = $(this).attr('class');
					let regex        = /unit-id-(\d+)/;

					if (cottageClass) {
						// Strip 'unit-id-' from the id
						let strippedClass = cottageClass.match(regex);

						if (!storedProperties.includes(parseInt(strippedClass[1], 10))) {
							// Remove highlight from the matching cottage
							$(this).find('.cottages-single-favourite').removeClass('favourite');

							// if the page url is /wishlist/ then...
							if (window.location.pathname === '/wishlist/') {

								// Find the .cottage-block with data-cottage-id = strippedClass[1], then delete it from the dom
								$('.cottage-block[data-cottage-id="' + strippedClass[1] + '"]').remove();

								// Now check how many .cottage-block elements are left
								// If none, then show the no-favourites message
								if ($('.cottage-block').length === 0) {
									$('#favourite-no-results').show();
								}
							}
						}
					}
				});
			}
			// console.log(storedProperties);
		});



		/**
		 * DELETE all Favourites.
		 *
		 * This is for testing
		 */
		// $(document).on('click', '.remove-all-favourites', function (e) {
		// 	e.preventDefault();

		// 	console.log(localStorage.getItem('properties'));

		// 	// Clear all properties from localStorage
		// 	localStorage.removeItem('properties');
		// 	console.log('All properties removed from favourites');
		// 	console.log(localStorage.getItem('properties'));

		// 	// Remove 'favourite' class from all elements
		// 	$('.cottages-single-favourite').removeClass('favourite');
		// });

		// HTML is:
		// <button class="remove-all-favourites">
		// 	DELETE
		// </button>
		/**
		 * DELETE all Favourites.
		 *
		 * This is for testing
		 */



		// Favourites page

		if ($('#advanced-search-results.favourites-page').length > 0) {
			// when favourites page loads, check if cookie exists and has valueSubmit
			// if yes get property ids from cookie
			// if not, show no favourites message

			if (storedProperties.length > 0) {
				// If storedProperties is not empty, proceed with the AJAX request

				$.ajax({
					url: admin_url_for_js,
					type: 'post',
					data: {
						action: 'get_favourite_properties',
						property_ids: JSON.stringify(storedProperties),
					},
					success: function (response) {
						var myObject = JSON.parse(response);

						$('#favourite-yes-results').append(myObject);

						setTimeout(function () {
							$('#favourite-checking').hide();
							$('#favourite-yes-results .cottage-block').show();
							$('#favourite-no-results').hide();


							$('#favourite-yes-results .cottages-single-favourite').addClass('favourite');

							// Setup the slider.
							var $slider = $('#favourite-yes-results .cottage-block .slider');

							// Show the slides after loading, prevents Content Layout Shift.
							$slider.on("init", function ( event, slick ) {
								$slider.css({
									visibility: "visible",
									height: "100%",
								});
							});

							$slider.slick({
								slidesToShow: 1,
								autoplay: false,
								dots: false,
								arrows: true,
								infinite: true,
								lazyLoad: 'anticipated',
							});

						}, 1000);
					},
					error: function (response) {
						$('#favourite-checking').hide();
						$('#favourite-no-results').show();
					},
				});
			} else {
				// If storedProperties is empty, show no favourites message
				$('#favourite-checking').hide();
				$('#favourite-no-results').show();
				$('#favourite-yes-results').hide();
			}
		}

		// Favourites page








		/**
		 * Search Results page or Landing page properties.
		 * Reset all the filters to the defaults.
		 */
		$('#reset_filters_submit').on('click', function () {

			// Reset select fields.
			$('#chc_adults').val("2");
			$('#chc_children').val("0");
			$('#chc_infants').val("0");
			$('.results-container .cottage-block').removeClass('hide-guests');
			$('#hidden-guests').val("NaN");

			$('#chc_pets').val("-1");
			$('.results-container .cottage-block').removeClass('hide-pets');

			// For rooms and bathrooms, the default option values are empty strings.
			$('#chc_rooms').val('');
			$('.results-container .cottage-block').removeClass('hide-bedrooms');

			$('#chc_bathrooms').val('');
			$('.results-container .cottage-block').removeClass('hide-bathrooms');

			// Uncheck all amenities checkboxes.
			$('input[name="chc_amenities[]"]').prop('checked', false);
			$('.results-container .cottage-block').removeClass('hide-amenities');

			// Reset the noUiSlider using the values from aria-valuemin and aria-valuemax
			if ($("#range-slider").length && $("#range-slider")[0].noUiSlider) {
				var lowerHandle = $("#range-slider").find('.noUi-handle-lower');
				var upperHandle = $("#range-slider").find('.noUi-handle-upper');
				var minVal = parseFloat(lowerHandle.attr('aria-valuemin'));
				var maxVal = parseFloat(upperHandle.attr('aria-valuemax'));
				$("#range-slider")[0].noUiSlider.set([minVal, maxVal]);
				$('.results-container .cottage-block').removeClass('hide-price');
			}

			// Re-calculate the property counter.
			var cottageCount = $('.results-container .cottage-block').length;
			$('.property-results-counter #results-count').text(cottageCount + ' properties');

		});



	});

	$(window).on('load', function () {

		/**
		 * Search Results page or Landing page properties.
		 * Automatically set the location dropdown value (filters panel) on page load.
		 */
		if ($('#tbCountries').length > 0) {

			// Programmatically set a value to the input on page load
			if (
				$('#advanced-search-results').data('location')
				&&
				$('#advanced-search-results').data('location') !== '0'
			) {
				$('#tbCountries').val($('#advanced-search-results').data('location'));
			}

			/**
			 * Search Results page or Landing page properties.
			 * Automatically set the extend date value (filters panel) on page load.
			 */
			var extendDate = $('#advanced-search-results').data('extend-date');
			$('.element-calendar-extended #plus_minus')
				.find('input[type="radio"][name="chc_extend_date"][value="' + extendDate + '"]')
				.prop('checked', true);

		}

	});

})(jQuery);
